import script from "./AlignmentLine.vue?vue&type=script&lang=ts&setup=true"
export * from "./AlignmentLine.vue?vue&type=script&lang=ts&setup=true"

import "./AlignmentLine.vue?vue&type=style&index=0&id=ed6fc00a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed6fc00a"]])

export default __exports__